import React from 'react';
import classnames from 'classnames';
import { ConfirmButton } from 'scy/buttons';
import {
  inputGroup,
  inputGroupPrefix,
  inputGroupInput,
  inputGroupButton
} from './styles.mod.scss';

export default function InputGroup({
  onSubmit,
  prefix,
  buttonText = 'Submit',
  className,
  inputProps = {}
}) {
  return (
    <form className={classnames(inputGroup, className)} onSubmit={onSubmit}>
      {prefix && <div className={inputGroupPrefix}>{prefix}</div>}
      <input className={inputGroupInput} {...inputProps} />
      <ConfirmButton className={inputGroupButton} type="submit">
        {buttonText}
      </ConfirmButton>
    </form>
  );
}
